/**
 * Resolve PostHog public browser config from a single project key + host.
 * Set per Vercel environment in the dashboard (`VITE_POSTHOG_KEY` /
 * `NEXT_PUBLIC_POSTHOG_KEY`); not managed via `vercel.json`.
 */

export type PosthogPublicEnvInput = {
  key?: string | null;
  host?: string | null;
};

export type ResolvedPosthogPublicConfig = {
  key: string | null;
  host: string;
  enabled: boolean;
};

export const DEFAULT_POSTHOG_HOST = 'https://eu.i.posthog.com';

function trimOrNull(value: string | null | undefined): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function resolvePosthogPublicConfig(
  input: PosthogPublicEnvInput,
): ResolvedPosthogPublicConfig {
  const key = trimOrNull(input.key);
  const host = trimOrNull(input.host) ?? DEFAULT_POSTHOG_HOST;

  return {
    key,
    host,
    enabled: Boolean(key),
  };
}
